import React from 'react';
import { PropInfo, CodeExample, LabelProps } from '@cimpress/react-components';
import LabelCode from '!raw-loader!./label.jsx';
import LabelDemo from './label.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const LabelDocs = () => {
  const propInfos: PropInfo<LabelProps>[] = [
    {
      name: 'status',
      type: 'string(required)',
      description: (
        <div>
          One of the following:
          <ul>
            <li>default</li>
            <li>primary</li>
            <li>success</li>
            <li>warning</li>
            <li>danger</li>
            <li>info</li>
          </ul>
        </div>
      ),
      default: 'default',
    },
    {
      name: 'size',
      type: 'string',
      description: (
        <div>
          One of the following:
          <ul>
            <li>sm</li>
            <li>lg</li>
          </ul>
          If not defined, will default to a medium size.
        </div>
      ),
      default: '',
    },
    {
      name: 'text',
      type: 'string(required)',
      description: 'The text shown on the label.',
      default: '',
    },
    {
      name: 'className',
      type: 'string',
      description: 'Additional class names to add to the label.',
    },
  ];

  return (
    <ComponentDoc name="Label" propInfos={propInfos}>
      <LabelDemo />
      <CodeExample code={LabelCode} />
    </ComponentDoc>
  );
};

export default LabelDocs;
